import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Camera, PencilSimpleLine } from "@phosphor-icons/react";
import useReviewViewer from "@/components/reviews/useReviewViewer";

export const OPEN_REVIEW_EVENT = "rfg:open-review-form";

export default function CustomerPhotos({ productId }) {
  const [reviews, setReviews] = useState(null);
  const { photos, openPhoto, viewer } = useReviewViewer(reviews || []);

  useEffect(() => {
    api.get("/reviews/photos", { params: { product_id: productId, limit: 60 } })
      .then((r) => setReviews(r.data || [])).catch(() => setReviews([]));
  }, [productId]);

  if (reviews === null) return null;
  return (
    <div data-testid="customer-photos" className="mt-6">
      <div className="flex items-center justify-between mb-3">
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground flex items-center gap-2">
          <Camera size={14} /> Customer photos {photos.length > 0 && <span data-testid="customer-photos-count">({photos.length})</span>}
        </div>
      </div>
      {photos.length ? (
        <div className="flex gap-2 overflow-x-auto pb-2 snap-x [scrollbar-width:thin]">
          {photos.map((p, i) => (
            <button key={p.key} type="button" data-testid={`customer-photo-${i}`} onClick={() => openPhoto(p.path)}
              className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-sm overflow-hidden border border-border hover:border-[#C84A31] transition-colors snap-start cursor-zoom-in">
              <img src={p.src} alt={p.alt} loading="lazy" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      ) : (
        <button type="button" data-testid="customer-photos-invite" onClick={() => window.dispatchEvent(new Event(OPEN_REVIEW_EVENT))}
          className="w-full border border-dashed border-border rounded-sm p-4 flex items-center gap-3 text-left hover:border-[#C84A31] transition-colors group">
          <span className="w-10 h-10 rounded-full bg-muted flex items-center justify-center group-hover:bg-[#C84A31]/10 transition-colors">
            <Camera size={18} className="text-[#C84A31]" />
          </span>
          <span className="flex-1">
            <span className="block text-sm font-display">No customer photos yet — be the first</span>
            <span className="block text-xs text-muted-foreground">Show off your catch in this gear with a quick review.</span>
          </span>
          <PencilSimpleLine size={16} className="text-muted-foreground group-hover:text-[#C84A31]" />
        </button>
      )}
      {viewer}
    </div>
  );
}
